
import { useState, useRef, useEffect } from "react"
import { GeoJSON } from 'react-leaflet/GeoJSON';
import { useMapEvent, useMapEvents } from 'react-leaflet/hooks'
import axios from 'axios';
import L from "leaflet";

import { divIcon } from "leaflet";
import { renderToStaticMarkup } from "react-dom/server";
import MarkerClusterGroup from "react-leaflet-cluster";
import * as turf from "@turf/turf";
import Table from 'react-bootstrap/Table';

import {
    Map,
    NavigationControl,
    FullscreenControl,
    GeolocateControl,
    Source,
    Layer,
    useMap,
    Popup
} from 'react-map-gl/maplibre';

const SilpWfsServer = axios.create({
    baseURL: "https://public-services.slip.wa.gov.au/public/rest/services/SLIP_Public_Services/Industry_and_Mining/MapServer/12/query?where=1%3D1&text=&objectIds=&time=&timeRelation=esriTimeRelationOverlaps&geometry=&geometryType=esriGeometryPolygon&inSR=&spatialRel=esriSpatialRelIntersects&distance=&units=esriSRUnit_Foot&relationParam=&outFields=*&returnGeometry=true&returnTrueCurves=false&maxAllowableOffset=&geometryPrecision=&outSR=&havingClause=&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&historicMoment=&returnDistinctValues=false&resultOffset=&resultRecordCount=&returnExtentOnly=false&sqlFormat=none&datumTransformation=&parameterValues=&rangeValues=&quantizationParameters=&featureEncoding=esriDefault&f=geojson"
})

export function querySection19WFSLibre(setSection19GeoJson) {
    SilpWfsServer.get().then((e) => {
        setSection19GeoJson(e.data);
    })
};

/* {
  "objectid": 1,
  "ge_num": 853080,
  "land_id": " S190000012       ",
  "fmt_land_id": "S19 12",
  "type": "S19 - SECTION 19",
  "status": "ACTIVE",
  "official_name": "",
  "purpose": "SECTION 19 - LATE MC'S 36/4346-4351 - URANIUM (YEELIRRIE) AGREEMENT",
  "managed_by": "Dept. of Mines, Industry Regulation and Safety",
  "file_ref": "113-84",
  "startdate": 444441600000,
  "enddate": 32503593600000,
  "confidential": "N",
  "extract_date": 1741737600000,
  "st_area(shape)": 0.0006572874604161699,
  "st_perimeter(shape)": 0.10203141238183969
}

*/
export function createSingleSection19PopupTable(feature, latLng, setClosed) {
    return <Popup latitude={latLng.lat} longitude={latLng.lng}
        anchor="bottom"
        onClose={() => setClosed(false)}>
        <Table striped bordered style={{ marginBottom: 0 }} >
            <tbody>
                <tr>
                    <td>Purpose:</td>
                    <td>{feature.properties.purpose}</td>
                </tr>
                <tr>
                    <td>Managed By:</td>
                    <td>{feature.properties.managed_by}</td>
                </tr>
            </tbody>
        </Table>
    </Popup >
}



export function Section19OverlayLibre({ overlayVisibility }) {
    const emptyGeoJson = {
        "type": "FeatureCollection",
        "name": "Mining_Tenements_DMIRS_003",
        "crs": { "type": "name", "properties": { "name": "urn:ogc:def:crs:EPSG::4283" } },
        "features": []
      };
    const [geoJson, SetGeoJson] = useState(emptyGeoJson);

    useEffect(() => {
        querySection19WFSLibre(SetGeoJson);
    }, [])

    const graticleFill = {
        id: 'section19-fill',
        type: 'fill',
        paint: { 'fill-color': '#FF3131', 'fill-opacity': 0.8 },
        layout: { visibility: `${overlayVisibility.section19 && overlayVisibility.tenements ? "visible" : "none"}` }
    };
    const graticleOutline = {
        id: 'section19-outline',
        type: 'line',
        paint: { 'line-color': "#FF3131", 'line-width': 3 },
        layout: { visibility: `${overlayVisibility.section19 && overlayVisibility.tenements? "visible" : "none"}` }
    };



    return <Source id="section19" type="geojson" data={geoJson}>
        <Layer  {...graticleFill} />
        <Layer {...graticleOutline} />
    </Source>

}